// Cashier Transactions Getters

export const getCashTransactionList = state => {
  return state.transactionsList
}

export const getCashTransactionInfo = state => {
  return state.transactionInfo
}

export const getCashList = state => {
  return state.cashList
}
